import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../shared/models/api-response.model';
import { ApiRoutes } from '../../../shared/constants/api-routes.constants';
import { toFormData } from '../../../shared/utils/form-data.util';
import {
  Raffle,
  RaffleRequest,
  RafflesByInfluencer,
} from '../../raffles/models/raffle.model';
import { Profile } from '../../profile/model/profile.model';

interface RaffleImage {
  imageUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class InfluencerService {
  constructor(private http: HttpClient) {}

  getRaffleByInfluencer(): Observable<ApiResponse<RafflesByInfluencer | null>> {
    return this.http.get<ApiResponse<RafflesByInfluencer | null>>(
      ApiRoutes.RAFFLE.GET_INFLUENCER_RAFFLE
    );
  }

  getRaffleByIdentifier(id: number): Observable<ApiResponse<Raffle>> {
    return this.http.get<ApiResponse<Raffle>>(
      ApiRoutes.RAFFLE.RAFFLE_BY_IDENTIFIER(id)
    );
  }

  getTrendingInfluencer(): Observable<ApiResponse<Profile | null>> {
    return this.http.get<ApiResponse<Profile | null>>(
      ApiRoutes.USER.TRENDING_USER
    );
  }

  getHomePageInfluencers(): Observable<ApiResponse<Profile[]>> {
    return this.http.get<ApiResponse<Profile[]>>(
      ApiRoutes.USER.GET_HOME_PAGE_USERS
    );
  }

  createRaffle(raffle: RaffleRequest): Observable<ApiResponse<Raffle | null>> {
    const filesOnly = raffle.raffleImages.filter(
      (img) => img instanceof File
    ) as File[];
    const formData = toFormData({ ...raffle, raffleImages: filesOnly }, [
      'raffleImages',
    ]);

    return this.http.post<ApiResponse<Raffle | null>>(
      ApiRoutes.RAFFLE.CREATE_RAFFLE,
      formData
    );
  }

  updateRaffle(
    raffle: RaffleRequest,
    id: number
  ): Observable<ApiResponse<Raffle | null>> {
    const filesOnly = raffle.raffleImages.filter(
      (img) => img instanceof File
    ) as File[];
    const formData = toFormData({ ...raffle, raffleImages: filesOnly }, [
      'raffleImages',
    ]);

    return this.http.put<ApiResponse<Raffle | null>>(
      ApiRoutes.RAFFLE.UPDATE_RAFFLE_BY_IDENTIFIER(id),
      formData
    );
  }

  deleteRaffleImage(imageId: number): Observable<ApiResponse<boolean | null>> {
    return this.http.delete<ApiResponse<boolean | null>>(
      ApiRoutes.RAFFLE.DELETE_RAFFLE_IMAGE(imageId)
    );
  }
}
